import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import {
  getMenuByRouter
} from '@/utils'
import routers from '@/router/routers'
import modules from "./modules";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    websocket: {},
    childUser: [],
    storeOpt: {},
    translate: null,
    sendBefore: '',
    assignMode: localStorage.getItem("assignMode") ? localStorage.getItem("assignMode") : 'invitation'
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
  },
  mutations: {
    setUser (state, user) {
      state.user = user;
    },
    setChildUser (state, data) {
      state.childUser = data;
      state.childUser.sort(function (a, b) {
        return b.status - a.status;
      })
    },
    // 设置子用户属性
    setUsersAttr: function (state, data) {
      for (let i=0; i<state.childUser.length; i++) {
        if (state.childUser[i].id == data.id) {
          state.childUser[i][data.attr] = data.value;
          break;
        }
      }
      state.childUser.sort(function (a, b) {
        return b.status - a.status;
      })
    },
    setWebsocket: function(state, websocket) {
      state.websocket = websocket;
    },
    closeConnect: function(state) {
      state.websocket.heartReset();
      state.websocket.close();
    },
    switdhAssignMode: function (state, value) {
      state.assignMode = value;
      localStorage.setItem("assignMode", value);
    },
    /**
     * 设置翻译
     * @param {[type]} state [description]
     * @param {[type]} value [description]
     */
    setTranslate: function (state, value) {
      state.translate = value;
    },
    // 设置选中
    activeStoreOptById: function (state, opt) {
      for (let i=0; i<state.storeOpt[opt.platform].length; i++) {
        state.storeOpt[opt.platform][i].active = false;
        if (opt.id == state.storeOpt[opt.platform][i].id) {
          state.storeOpt[opt.platform][i].active = true;
        }
      }
    },
    setSendBefore: function (state, value) {
      state.sendBefore = value;
    },
    clear: function() {
      this.commit("lazada/clear");
      this.commit("shopee/clear");
    },
  },
  modules: modules,
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== "production"
});
